import { getLoanSearch } from '@/graphql/queries/banking/loan';
import { getProviderWithLoans } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/loans';
import { COOKIE_LOAN_SEARCH } from '@/constants/cookies';

export default async ({ $apolloQuery, $cookies, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const code = $cookies.get(COOKIE_LOAN_SEARCH);
  const defaultSearch = () => {
    $cookies.remove(COOKIE_LOAN_SEARCH);
    store.commit('search/reset', { type: 'loan' });
  };
  if (code && typeof code === 'string') {
    await $apolloQuery(getLoanSearch, { code }).then(search => store.commit('search/set', search)).catch(defaultSearch);
  } else {
    defaultSearch();
  }

  await $apolloQuery(getProviderWithLoans, { slug: route.params.provider }).then(lender => {
    const description = store.$i18n.t('lender.description', { lender: lender.name });
    const title = store.$i18n.t('lender.title', { lender: lender.name });
    store.commit('pageContent/setHead', { title, description });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/banking', '/money/'],
      ['i18n/loans', '/compare-loans/'],
      ['i18n/lenders', '/compare-loans/lenders/'],
      lender.name
    ]);
    store.commit('blog/setList', lender.articles);
    store.commit('products/setList', lender.loans);

    delete lender.articles;
    delete lender.loans;
    store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
    store.commit('providers/set', lender);
  });
};
